/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { tunneledMcpListServers } from "../funcs/tunneledMcpListServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListTunneledMcpServersResult } from "../models/components/listtunneledmcpserversresult.js";
import {
  ListTunneledMcpServersRequest,
  ListTunneledMcpServersSecurity,
} from "../models/operations/listtunneledmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type TunneledMcpServersQueryData = ListTunneledMcpServersResult;

export function prefetchTunneledMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListTunneledMcpServersRequest | undefined,
  security?: ListTunneledMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTunneledMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTunneledMcpServersQuery(
  client$: GramCore,
  request?: ListTunneledMcpServersRequest | undefined,
  security?: ListTunneledMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<TunneledMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyTunneledMcpServers({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function tunneledMcpServersQueryFn(
      ctx,
    ): Promise<TunneledMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(tunneledMcpListServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTunneledMcpServers(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "tunneledMcp", "listServers", parameters];
}
